var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "main", class: _vm.containerClasses, style: _vm.cssVariableStyles },
    [
      _c(
        "transition",
        {
          attrs: { name: "enlarge" },
          on: {
            "after-leave": function () {
              if (!_vm.bubble.isOpen) {
                _vm.notifyClosed()
              }
            },
          },
        },
        [
          _vm.bubble.isOpen
            ? _c("div", { staticClass: "main-wrapper" }, [
                _c(
                  "div",
                  { staticClass: "main-wrapper__tab-content" },
                  [
                    _vm.isTab("chat")
                      ? _c("chat-tab", {
                          attrs: {
                            "show-close-button": _vm.showCloseButton,
                            "is-typing-enabled": _vm.isTypingEnabled,
                          },
                          on: { "toggle-chat": _vm.toggleChat },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isTab("wizard") ? _c("wizard-tab") : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "main-wrapper__footer" },
                  [
                    _c("feature-flag", { attrs: { name: "one_solution" } }, [
                      _c(
                        "div",
                        { staticClass: "main-wrapper__tab-bar" },
                        [
                          _c("tab-bar", {
                            attrs: { "current-tab": _vm.currentTab },
                            on: { "tab-change": _vm.onTabChanged },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "main-wrapper__privacy-powered" },
                      [
                        _c("chat-footer", {
                          attrs: {
                            "customer-id": _vm.customerId,
                            "privacy-policy": _vm.privacyPolicy,
                            "chatchamp-link-clickable":
                              _vm.channel.chatchampLinkClickable,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.channel
        ? _c(
            "div",
            { staticClass: "bubble-container" },
            [
              _c("chat-bubble", {
                ref: "chatBubble",
                attrs: { "is-open": _vm.bubble.isOpen },
                on: { click: _vm.toggleChat },
              }),
              _vm._v(" "),
              _c(
                "transition",
                {
                  attrs: { name: "enlarge" },
                  on: { "after-enter": _vm.notifyWelcomeMessageShown },
                },
                [
                  _vm.isShowingWelcomeMessage
                    ? _c("welcome-message", {
                        attrs: { message: _vm.welcomeMessage.welcomeMessage },
                        on: {
                          "~click": function ($event) {
                            return _vm.welcomeMessageClick.apply(
                              null,
                              arguments
                            )
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }